import React from "react";
import { Row, Col, Form, Select } from "antd";

import ProfileFormGroup from "./ProfileFormGroup";

const SettingsRankPanel = ({ currentPlayer, userData, setProfile }) => {
    let profileDataKey;

    if (currentPlayer === 1) {
        profileDataKey = "profile_p1";
    } else {
        profileDataKey = "profile_p2";
    }

    const handleOnChange = (changedFields) => {
        let profileObject = {
            ...userData[profileDataKey],
        };

        changedFields.forEach((field) => {
            let name = field.name[0];
            let value = field.value;

            profileObject[name] = value;
        });

        setProfile(profileObject, currentPlayer);
    };

    return (
        <Row gutter={16} style={{ marginBottom: `16px` }}>
            <Col span={24}>
                <ProfileFormGroup
                    cardProps={{
                        title: "Scoreboard",
                    }}
                    formProps={{
                        onFieldsChange: handleOnChange,
                        fields: [
                            {
                                name: ["rankPanelDifficulty"],
                                value: userData[profileDataKey]
                                    .rankPanelDifficulty,
                            },
                        ],
                    }}
                >
                    <Form.Item
                        name="rankPanelDifficulty"
                        label="Scoreboard Difficulty"
                    >
                        <Select
                            placeholder="Select a difficulty"
                            style={{ width: "100%" }}
                        >
                            <Select.Option value={1}>Easy</Select.Option>
                            <Select.Option value={2}>Normal</Select.Option>
                            <Select.Option value={3}>Hard</Select.Option>
                            <Select.Option value={4}>Oni</Select.Option>
                            <Select.Option value={5}>Ura & Oni</Select.Option>
                        </Select>
                    </Form.Item>
                </ProfileFormGroup>
            </Col>
        </Row>
    );
};

export default SettingsRankPanel;
